import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Resolves the precomputed Resilience Priority synthesis overlay PNG +
 * geographic bounds for (mill, drive_time). 5-tier priority spectrum
 * painted on private timberland — score = WHP class + RD class, binned
 * into 5 tiers and colored with the WHP RdYlGn ramp. Used by the Carbon
 * Defense scenario's insight step (and selectable from the layer dropdown
 * for free exploration).
 */
export const useResiliencePriorityOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.resiliencePriorityOverlayMeta,
  pngPath: API_CONFIG.s3.paths.resiliencePriorityOverlay,
});
